var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMembers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 16,
    fill: "#F4413D",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1917 32.4757C39.5029 32.4757 37.9178 32.8307 36.5846 33.4325C41.251 34.8367 44.5545 38.2007 44.6434 42.1357C47.0729 41.8116 49.6949 40.8549 49.6949 38.247C49.6949 35.1145 45.7989 32.4757 41.1917 32.4757Z",
    fill: "#F4413D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1473 30.2539H41.1769C44.3323 30.2539 46.9099 27.5689 46.9099 24.2975C46.9099 21.0107 44.3323 18.3256 41.1769 18.3256C40.5547 18.3256 39.9622 18.4337 39.3992 18.6188C40.4214 20.1928 41.0139 22.0908 41.0139 24.1432C41.0288 26.2264 40.4066 28.2325 39.2363 29.899C39.8436 30.1305 40.4806 30.2539 41.1473 30.2539Z",
    fill: "#F4413D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5999 33.4171C25.2667 32.8307 23.6816 32.4757 22.0076 32.4757C17.4005 32.4757 13.5044 35.1145 13.5044 38.247C13.5044 40.8549 16.1116 41.7962 18.5411 42.1357C18.6152 38.2007 21.9187 34.8367 26.5999 33.4171Z",
    fill: "#F4413D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0076 30.2539H22.0521C22.7187 30.2539 23.3557 30.1305 23.9631 29.899C22.8372 28.2942 22.1706 26.3036 22.1706 24.1432C22.1706 22.0908 22.7632 20.1928 23.7853 18.6188C23.2224 18.4337 22.6298 18.3256 22.0076 18.3256C18.8523 18.3256 16.2895 21.0107 16.2895 24.2975C16.2895 27.5689 18.8523 30.2539 22.0076 30.2539Z",
    fill: "#F4413D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5917 35.0021C25.7239 35.0021 20.7656 38.3291 20.7656 42.2671C20.7656 47.3594 28.9133 47.3594 31.5917 47.3594C36.2403 47.3594 42.4207 46.8348 42.4207 42.2996C42.4207 38.343 37.4609 35.0021 31.5917 35.0021Z",
    fill: "#F4413D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5932 31.6521H31.6421C33.5605 31.6459 35.3619 30.8605 36.7129 29.4423C38.0655 28.0242 38.8062 26.1432 38.7987 24.1479C38.7987 20.0077 35.5678 16.6406 31.5932 16.6406C27.6202 16.6406 24.3892 20.0077 24.3892 24.1479C24.3892 28.285 27.6202 31.6521 31.5932 31.6521Z",
    fill: "#F4413D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembers);
export default __webpack_public_path__ + "static/media/members.34c1bd2cd223e0553fb4ead3d77adc28.svg";
export { ForwardRef as ReactComponent };